<template>
  <div class="account-page">
    <div class="account-tabs" role="tablist" :aria-label="t('nav.account')">
      <router-link
        to="/profile"
        role="tab"
        class="account-tab"
        :class="{ active: tab === 'profile' }"
        :aria-selected="tab === 'profile'"
      >
        {{ t('nav.profile') }}
      </router-link>
      <router-link
        to="/settings"
        role="tab"
        class="account-tab"
        :class="{ active: tab === 'settings' }"
        :aria-selected="tab === 'settings'"
      >
        {{ t('nav.settings') }}
      </router-link>
    </div>
    <Profile v-if="tab === 'profile'" />
    <Settings v-else />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useI18n } from '../i18n/t'
import Profile from './Profile.vue'
import Settings from './Settings.vue'

const { t } = useI18n()
const route = useRoute()
const tab = computed(() => (route.name === 'settings' ? 'settings' : 'profile'))
</script>

<style scoped>
.account-page {
  width: 100%;
}

.account-page :deep(.profile > header h1),
.account-page :deep(.settings > header h1) {
  display: none;
}

.account-page :deep(.profile),
.account-page :deep(.settings) {
  width: min(960px, 100%);
  padding-top: 8px;
}

.account-tabs {
  display: flex;
  gap: 4px;
  width: min(960px, 100%);
  margin: 0 auto;
  padding: 20px 16px 0;
}

.account-tab {
  min-height: 40px;
  padding: 0 20px;
  border-radius: 20px;
  color: var(--md-sys-color-on-surface-variant);
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0.1px;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
  transition: background-color 200ms cubic-bezier(0.2, 0, 0, 1);
}

.account-tab:hover {
  background: var(--md-state-layer);
  color: var(--md-sys-color-on-surface);
}

.account-tab.active {
  background: var(--md-sys-color-primary-container);
  color: var(--md-sys-color-on-primary-container);
}

@media (max-width: 720px) {
  .account-tabs {
    padding: 16px 16px 0;
  }
}

@media (max-height: 500px) and (max-width: 1100px) {
  .account-tabs {
    padding: 8px 16px 0;
  }
}
</style>
